module.exports = __webpack_public_path__ + "static/img/baoZhuang.2a25e8cd.jpg";